import { render } from "./MedicalCertificate.vue?vue&type=template&id=723d61b2&scoped=true"
import script from "./MedicalCertificate.vue?vue&type=script&lang=js"
export * from "./MedicalCertificate.vue?vue&type=script&lang=js"

import "./MedicalCertificate.vue?vue&type=style&index=0&id=723d61b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723d61b2"]])

export default __exports__